var _path, _text, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "615px",
    height: "462px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(255, 242, 45)",
    d: "M549.182,0.997 C448.8,50.496 386.155,93.662 306.948,2.326 C303.203,26.3 283.255,83.569 250.497,98.218 C223.397,110.337 147.291,93.981 123.445,70.388 C135.248,88.759 160.655,136.66 103.421,175.948 C46.187,215.830 44.788,216.115 0.0,227.297 C62.510,236.571 84.947,265.307 87.647,286.598 C90.346,307.889 59.446,343.770 33.508,374.89 C132.149,363.5 167.674,366.768 190.513,385.104 C213.351,403.441 233.733,423.362 242.514,461.989 C273.44,397.998 304.742,390.538 331.325,385.197 C357.909,379.857 403.302,390.353 417.441,413.712 C416.553,365.858 453.729,336.555 472.136,331.766 C490.543,326.976 548.181,325.221 571.663,332.512 C503.954,281.708 545.235,204.440 555.586,193.627 C565.938,182.814 591.674,151.443 614.995,143.484 C573.548,128.886 541.923,115.988 538.499,98.118 C535.74,80.248 552.968,0.854 549.182,0.997 Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    kerning: "auto",
    fontFamily: "Myriad Pro",
    fill: "rgb(0, 0, 0)",
    transform: "matrix( 0.82575924173457, -0.18904489805205, 0.18911726871224, 0.82876277016766,174.475625147049, 243.720434788007)",
    fontSize: "118.008px"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontSize: "118.008px",
    fontFamily: "KomikaTitle",
    fill: "#EC1F26"
  }, "La&#32;liste"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    kerning: "auto",
    fontFamily: "Myriad Pro",
    fill: "rgb(0, 0, 0)",
    transform: "matrix( 0.82575924173457, -0.18904489805205, 0.18911726871224, 0.82876277016766,162.273422518883, 347.23095153308)",
    fontSize: "118.008px"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontSize: "118.008px",
    fontFamily: "KomikaTitle",
    fill: "#EC1F26"
  }, "est&#32;vide"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoItem);
export default __webpack_public_path__ + "static/media/noItem.4db6f16a.svg";
export { ForwardRef as ReactComponent };